import { Field, TextOutput } from 'Components/Core';
import { IFieldProps } from 'Components/Core/Field/types';
import FormattedText from 'Components/Core/FormattedText';
import { hasEmptyValue, valueOrDefault } from 'Lib/Any';
import { pipe } from 'ramda';
import { useSelector } from 'react-redux';
import { IWithInjectedProps, withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { IWorksheetComponent } from '../../../Core';

let LowerBoundResultField: React.FC<
  IWorksheetComponent &
    Omit<IFieldProps & IWithInjectedProps, 'input' | 'value'> & {
      isLowerBoundFieldName: string;
    }
> = ({ name, isLowerBoundFieldName, createWorksheetSelector, ...props }) => {
  const isLowerBound = useSelector(pipe(createWorksheetSelector!(isLowerBoundFieldName), valueOrDefault(false)));
  const isFieldEmpty = useSelector(pipe(createWorksheetSelector!(name), (x) => hasEmptyValue(x)));

  return (
    <Field
      input={<TextOutput />}
      {...props}
      value={[isLowerBound && !isFieldEmpty ? '> ' : '', <FormattedText blankReplacement="-" name={name} key={0} />]}
      name={name}
    />
  );
};
LowerBoundResultField = withInjectedProps(LowerBoundResultField);

export default LowerBoundResultField;
export { LowerBoundResultField };
